import React from 'react';
import withStyles from 'components/common/wrappers/withStyles';

function Rewards({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <path
        fill={color}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        d="M75 22.45H59.18c1.135-.774 2.11-1.544 2.79-2.234C66 16.16 66 9.56 61.97 5.506c-3.915-3.94-10.745-3.945-14.665 0-2.165 2.175-7.92 11.03-7.125 16.945h-.36c.79-5.915-4.96-14.77-7.125-16.945-3.92-3.945-10.75-3.94-14.665 0C14 9.56 14 16.16 18.025 20.216c.685.69 1.66 1.46 2.795 2.235H5c-2.755 0-5 2.245-5 5v12.5a2.5 2.5 0 002.5 2.5H5v30c0 2.755 2.245 5 5 5h60c2.755 0 5-2.245 5-5v-30h2.5a2.5 2.5 0 002.5-2.5v-12.5c0-2.755-2.245-5-5-5zM21.575 9.03a5.31 5.31 0 013.79-1.58c1.425 0 2.77.56 3.785 1.58 3.37 3.39 6.72 12.05 5.555 13.256 0 0-.21.165-.925.165-3.455 0-10.05-3.59-12.205-5.76-2.095-2.11-2.095-5.55 0-7.66zM37.5 72.45H10v-30h27.5v30zm0-35H5v-10h32.5v10zM50.85 9.03c2.03-2.034 5.55-2.03 7.575 0 2.095 2.11 2.095 5.55 0 7.66-2.155 2.17-8.75 5.76-12.205 5.76-.715 0-.925-.16-.93-.164-1.16-1.205 2.19-9.865 5.56-13.255zM70 72.45H42.5v-30H70v30zm5-35H42.5v-10H75v10z"
        transform="translate(10 10)"
      />
    </svg>
  );
}

Rewards.defaultProps = {
  color: 'white',
};

export default withStyles(Rewards);
